import { EndPc } from './End/End.pc';
import { EndMobile } from './End/End.mobile';
import { useIsMobile } from '../../../hook/useIsMobile';

export const End = ({
  goOfflineTab,
  isEarlyEnd,
}: {
  goOfflineTab: () => void;
  isEarlyEnd: boolean;
}) => {
  const isMobile = useIsMobile();
  return isMobile ? (
    <EndMobile goOfflineTab={goOfflineTab} isEarlyEnd={!isEarlyEnd} />
  ) : (
    <EndPc goOfflineTab={goOfflineTab} isEarlyEnd={isEarlyEnd} />
  );
};
